import store from '../../store';
import LABEL_CONST from '@components/common/globalization';
import { getObjectValue } from '@utility/utills';
import { GET_BRAND_THEME_URL_SUCCESS } from '../../reducers/theme';

const fireboardVariables = type => {
  const newState = store?.getState();
  switch (type) {
    case 'LABEL':
      return {
        ...LABEL_CONST,
        ...(getObjectValue(() => newState.theme.variableProperties, {}).label ||
          {}),
        CURRENCY_SYMBOL: '$',
      };
    default:
      return LABEL_CONST;
  }
};
let labelData = fireboardVariables('LABEL');
store?.subscribe(() => {
  const lastAction = store?.getState()?.lastAction;
  if (lastAction.type === GET_BRAND_THEME_URL_SUCCESS) {
    labelData = fireboardVariables('LABEL');
  }
});
export let FLABEL = () => labelData;
export default fireboardVariables;